import React, { Component }  from 'react';

class HelpPage extends Component {
    componentDidMount() {
        this.props.setHeader();
    };

    render() {
        return (
            <p>Help</p>
        )
    }
}

export default HelpPage;